export class Tag {
  id: string;
  name: string;
}
